var map = {
	"./axia/icons/ppt.svg": 596711,
	"./boomea/boomea/icons/ppt.svg": 861515,
	"./boomea/icons/ppt.svg": 625353,
	"./simplifi/icons/ppt.svg": 419967
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 517260;
module.exports = webpackAsyncContext;